import React from "react";
import variables from "../Story/variables";
import PropTypes from 'prop-types';

const V = (props) => {
    const getV = () => {
        const vals = variables;
        return eval(`vals.${props.children}`);
    };

    return (
        <span>{props.callback ? props.callback() : getV()}</span>
    )
};

V.propTypes = { callback: PropTypes.func };

export default V;